/* Atelier - the photo upload control.

   Kept out of the stylesheet because a stylesheet cannot win here. Both the widget and the
   app around it write their appearance as inline declarations carrying !important:

     button   color: rgb(255,255,255) !important; border-radius: 3px !important;
              padding: 10px !important; height: inherit !important; ...
     label    font-weight: 300 !important; letter-spacing: inherit !important

   Inline !important outranks !important in any sheet. A CSS attempt set the button's
   background (which the widget does not mark important) and left its colour alone, giving a
   white button with white text.

   The guard is the delicate part, and it has been wrong twice:

     1. Comparing el.style.getPropertyValue('background') to '#ffffff' never matched, because
        the browser serialises the shorthand differently. Every mutation rewrote the style,
        which triggered the observer, which rewrote it again.
     2. Comparing every declared property against the computed style had the same effect for
        a subtler reason: font-family comes back as '"Hanken Grotesk", -apple-system,
        sans-serif' with double quotes, which never equals the single-quoted string written
        here. The loop returned, and a read could land on either state - the button showed
        white on one page and the app's orange on the next.

   So the check list is narrow and made only of properties whose computed form is stable:
   colours, radius, height. Everything else is applied but not compared. A hard cap ends the
   cycle even if a future widget version fights back. */
(function () {
  'use strict';

  var INK = 'rgb(43, 17, 25)';
  var MUTE = 'rgb(108, 85, 96)';
  var LINE = 'rgba(43, 17, 25, 0.28)';
  var WHITE = 'rgb(255, 255, 255)';

  var MAX_APPLIES = 24;

  var BUTTON = {
    check: ['background-color', 'color', 'border-radius', 'height'],
    style: {
      'background-color': WHITE,
      'background-image': 'none',
      'color': INK,
      'border-width': '1px',
      'border-style': 'solid',
      'border-color': LINE,
      'border-radius': '999px',
      'height': '44px',
      'line-height': '42px',
      'padding-top': '0px',
      'padding-bottom': '0px',
      'padding-left': '22px',
      'padding-right': '22px',
      'font-family': "'Hanken Grotesk', -apple-system, sans-serif",
      'font-size': '12px',
      'font-weight': '700',
      'letter-spacing': '0.1em',
      'text-transform': 'uppercase'
    }
  };

  var LABEL = {
    check: ['color', 'font-size', 'font-weight'],
    style: {
      'margin-top': '0px',
      'margin-bottom': '4px',
      'font-family': "'Hanken Grotesk', -apple-system, sans-serif",
      'font-size': '14px',
      'font-weight': '700',
      'letter-spacing': '0.01em',
      'color': INK
    }
  };

  var HINT = {
    check: ['color', 'font-size'],
    style: {
      'margin-top': '0px',
      'margin-bottom': '14px',
      'font-family': "'Hanken Grotesk', -apple-system, sans-serif",
      'font-size': '13px',
      'font-weight': '400',
      'line-height': '1.45',
      'letter-spacing': '0.01em',
      'color': MUTE
    }
  };

  function settled(el, spec) {
    var cs = getComputedStyle(el);
    for (var i = 0; i < spec.check.length; i++) {
      var name = spec.check[i];
      if (cs.getPropertyValue(name) !== spec.style[name]) return false;
    }
    return true;
  }

  function write(el, spec) {
    var n = (parseInt(el.getAttribute('data-atelier-applies'), 10) || 0) + 1;
    el.setAttribute('data-atelier-applies', String(n));
    if (n > MAX_APPLIES) return;

    for (var name in spec.style) {
      el.style.setProperty(name, spec.style[name], 'important');
    }
  }

  function keep(el, spec) {
    if (el.getAttribute('data-atelier-dressed') !== '1') {
      el.setAttribute('data-atelier-dressed', '1');
      /* The widget re-renders on upload, on removal and on error, restoring its own inline
         styles. */
      new MutationObserver(function () {
        if (!settled(el, spec)) write(el, spec);
      }).observe(el, { attributes: true, attributeFilter: ['style'] });
    }
    if (!settled(el, spec)) write(el, spec);
  }

  /* The app's label reads "Upload a file: *" at font-weight 300. Next to a bare button that
     was the whole instruction, and it did not read as one. It gets the weight of a field
     label, and a line underneath saying what the control does. */
  function hint(row, label) {
    var existing = row.querySelector('.gf-upload-hint');
    if (existing) {
      keep(existing, HINT);
      return;
    }
    var p = document.createElement('p');
    p.className = 'gf-upload-hint';
    p.textContent = 'Choose a photo from your device.';
    label.parentNode.insertBefore(p, label.nextSibling);
    keep(p, HINT);
  }

  function scan() {
    [].forEach.call(document.querySelectorAll('.uploadcare--widget__button'), function (btn) {
      keep(btn, BUTTON);
    });

    var pu = document.getElementById('photouploadapp');
    if (!pu) return;

    [].forEach.call(pu.querySelectorAll('[id^="selBtn_"]'), function (row) {
      var label = row.querySelector('p:not(.gf-upload-hint)');
      if (!label) return;
      keep(label, LABEL);
      hint(row, label);
    });
  }

  function init() {
    scan();

    var info = document.querySelector('.product__info-container');
    if (info) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = window.setTimeout(function () { pending = null; scan(); }, 160);
      }).observe(info, { childList: true, subtree: true });
    }

    [600, 1800, 4000, 8000, 12000].forEach(function (ms) { window.setTimeout(scan, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();